export const TRANSACTION_TYPE = {
  TRANSFER: 'transfer',
  PURCHARSE: 'purchase',
  REFUND: 'refund',
};
